import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var AlignHorizontalCentre02 = function AlignHorizontalCentre02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M16 10c.9319 0 1.3978 0 1.7654-.1522.49-.203.8794-.5924 1.0824-1.0824C19 8.3978 19 7.9319 19 7s0-1.3978-.1522-1.7654a2 2 0 0 0-1.0824-1.0824C17.3978 4 16.9319 4 16 4H8c-.9319 0-1.3978 0-1.7654.1522a2 2 0 0 0-1.0824 1.0824C5 5.6022 5 6.0681 5 7s0 1.3978.1522 1.7654a2 2 0 0 0 1.0824 1.0824C6.6022 10 7.0681 10 8 10zm2 10c.9319 0 1.3978 0 1.7654-.1522.49-.203.8794-.5924 1.0824-1.0824C21 18.3978 21 17.9319 21 17s0-1.3978-.1522-1.7654a2 2 0 0 0-1.0824-1.0824C19.3978 14 18.9319 14 18 14H6c-.9319 0-1.3978 0-1.7654.1522-.49.203-.8794.5924-1.0824 1.0824C3 15.6022 3 16.0681 3 17s0 1.3978.1522 1.7654c.203.49.5924.8794 1.0824 1.0824C4.6022 20 5.0681 20 6 20z"
    })
  }));
};
export default AlignHorizontalCentre02;